import React from "react";
import Accordion from "./Accordion";

const LeaderboardTable = ({ tableRows, trophyHeaders }) => (
  <div className="accordion-table">
    {tableRows.map((data, index) => (
      <Accordion
        key={index}
        data={data}
        position={index + 4}
        trophyHeaders={trophyHeaders}
      />
    ))}
  </div>
);

export default LeaderboardTable;
